/**
 * WebGL availability preflight.
 *
 * MapKit JS crashes with an unhandled promise rejection deep inside its
 * own WebGL renderer when `canvas.getContext('webgl')` returns null
 * (per-tab context budget exhausted, GPU process churn, software
 * rendering). That rejection bypasses React error boundaries entirely,
 * so callers gate the `<Map>` RENDER on this probe instead and fall
 * back to the non-map UI (venue search + address fields).
 *
 * The probe context is released immediately via WEBGL_lose_context —
 * the whole point is not to consume a slot from Chrome's ~16/tab
 * budget ourselves.
 */
export function isWebGLAvailable(): boolean {
  try {
    const canvas = document.createElement('canvas');
    const gl = canvas.getContext('webgl2') ?? canvas.getContext('webgl');
    if (!gl) return false;
    gl.getExtension('WEBGL_lose_context')?.loseContext();
    return true;
  } catch {
    return false;
  }
}
